export const getConfig = () => {
  // Read from window.runtimeConfig (injected at container start) with fallback to build-time env vars
  const runtimeConfig = window.runtimeConfig || {};

  return {
    VITE_API_URL: runtimeConfig.VITE_API_URL || import.meta.env.VITE_API_URL,
    VITE_APP_ENV: runtimeConfig.VITE_APP_ENV || import.meta.env.VITE_APP_ENV,
    VITE_DEBUG: runtimeConfig.VITE_DEBUG || import.meta.env.VITE_DEBUG,
  };
};
